const PricingTable = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Common Repair Pricing</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Transparent pricing with no hidden fees. Contact us for a free quote on your specific repair needs.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-lg">
            <thead className="bg-primary text-white">
              <tr>
                <th className="py-3 px-4 text-left">Service</th>
                <th className="py-3 px-4 text-left">iPhone</th>
                <th className="py-3 px-4 text-left">Samsung</th>
                <th className="py-3 px-4 text-left">Other Brands</th>
                <th className="py-3 px-4 text-left">Turnaround Time</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              <tr className="hover:bg-neutral">
                <td className="py-3 px-4 font-medium">Screen Replacement</td>
                <td className="py-3 px-4">$79 - $199</td>
                <td className="py-3 px-4">$99 - $249</td>
                <td className="py-3 px-4">$89 - $179</td>
                <td className="py-3 px-4">1-2 hours</td>
              </tr>
              <tr className="hover:bg-neutral">
                <td className="py-3 px-4 font-medium">Battery Replacement</td>
                <td className="py-3 px-4">$49 - $79</td>
                <td className="py-3 px-4">$59 - $89</td>
                <td className="py-3 px-4">$49 - $99</td>
                <td className="py-3 px-4">30-60 minutes</td>
              </tr>
              <tr className="hover:bg-neutral">
                <td className="py-3 px-4 font-medium">Charging Port Repair</td>
                <td className="py-3 px-4">$69 - $89</td>
                <td className="py-3 px-4">$79 - $99</td>
                <td className="py-3 px-4">$79 - $119</td>
                <td className="py-3 px-4">1-2 hours</td>
              </tr>
              <tr className="hover:bg-neutral">
                <td className="py-3 px-4 font-medium">Water Damage Repair</td>
                <td className="py-3 px-4">$99 - $199</td>
                <td className="py-3 px-4">$99 - $199</td>
                <td className="py-3 px-4">$99 - $199</td>
                <td className="py-3 px-4">24-48 hours</td>
              </tr>
              <tr className="hover:bg-neutral">
                <td className="py-3 px-4 font-medium">Data Recovery</td>
                <td className="py-3 px-4">$99 - $149</td>
                <td className="py-3 px-4">$99 - $149</td>
                <td className="py-3 px-4">$99 - $169</td>
                <td className="py-3 px-4">24-72 hours</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center mt-8 text-gray-600">
          <p>* Prices may vary based on device model and extent of damage. All repairs include parts and labor.</p>
          <a href="#" className="text-primary font-medium hover:text-[#FF6633] transition-colors mt-4 inline-block">
            Download Complete Price List (PDF)
          </a>
        </div>
      </div>
    </section>
  );
};

export default PricingTable;
